import * as l from "../../lib/littlejs.esm";
import { tilesize, tilesheets } from '../const/tiles.ts';
import Globals from "../globals.ts";
class Chip extends l.EngineObject {
    constructor(pos) {
        const chipTile = l.tile(0, tilesize, tilesheets.CHIP_JUMPING);
        super(pos, l.vec2(0.25, 0.25), chipTile, 0, l.hsl(0, 0, 1), 1);
        this.x = 0;
        this.y = 0;
        this.controlling = false;
        this.visible = true;
        this.health = 1;
        this.battery = 100;
        this.baseColor = l.hsl(1, 1, 1);
        this.grayColor = l.hsl(0, 0, 0.2);
        this.walkFrame = 0;
        this.walkTimer = 0;
        this.collideTiles = true;
        this.collideSolidObjects = true;
        this.controlling = false;
        this.mass = .1;
        this.gravityScale = 0.2;
    }
    update() {
        this.color = this.baseColor.copy();
        this.color.a = this.visible ? 1 : 0;
        // If we don't control Chip we gray it out and just update its position with gravity
        if (!this.controlling) {
            // this.color = this.grayColor;
            super.update();
            return;
        }
        // Key transfer
        if (Globals.rex && !Globals.rexHasKey && Globals.keys > 0) {
            if (this.pos.distance(Globals.rex.pos) < 1.0) {
                this.transferKeyToRex();
            }
        }
        // Movement controls
        const batteryCostMove = 0.1;
        const batteryCostFly = 0.5;
        const speed = 0.1;
        const flyForce = .01;
        const maxFlyginSpeed = 0.1;
        let isMoving = false;
        let isFlying = false;
        if (this.battery > 0) {
            // Check if game is in levelStart state - if so, don't allow movement
            if (Globals.gameState !== 'levelStart') {
                if (l.keyIsDown('ArrowLeft') || l.keyIsDown('KeyA')) {
                    this.velocity.x = -speed;
                    this.battery -= batteryCostMove;
                    isMoving = true;
                    this.mirror = true; // Mirror horizontally when walking left
                }
                else if (l.keyIsDown('ArrowRight') || l.keyIsDown('KeyD')) {
                    this.velocity.x = speed;
                    this.battery -= batteryCostMove;
                    isMoving = true;
                    this.mirror = false; // No mirror when walking right
                }
                else {
                    this.velocity.x *= 0.8; // friction
                }
                if ((l.keyIsDown('Space') || l.keyIsDown('ArrowUp'))) {
                    // Linear progression, we slow down the acceleration when we
                    // get closer to 0.1 velocity so the player can't accelerate
                    // to infinity
                    let acceleration = (maxFlyginSpeed - this.velocity.y) / 5;
                    this.velocity.y += acceleration;
                    this.battery -= batteryCostFly;
                    isFlying = true;
                }
            }
        }
        else {
            l.drawText("Chip has run out or battery", l.vec2(this.pos.x, this.pos.y + 0.25), 0.125);
        }
        // Animation logic
        if (isFlying) {
            this.tileInfo = l.tile(1, tilesize, tilesheets.CHIP_JUMPING);
        }
        else if (isMoving) {
            this.walkTimer += l.timeDelta;
            if (this.walkTimer > 0.1) { // Change frame every 0.1 seconds
                this.walkFrame = (this.walkFrame + 1) % 6;
                this.walkTimer = 0;
                this.tileInfo = l.tile(this.walkFrame, tilesize, tilesheets.CHIP_WALKING);
            }
        }
        else {
            // Reset to jumping sprite when not moving
            this.tileInfo = l.tile(0, tilesize, tilesheets.CHIP_JUMPING);
            this.walkFrame = 0;
            this.walkTimer = 0;
        }
        super.update();
    }
    // When Chip takes damage, he instantly dies because he only has 1 HP
    takeDamage(damage) {
        this.health -= damage;
    }
    /**
     * Transfer key from Chip to Rex when close.
     */
    transferKeyToRex() {
        Globals.rexHasKey = true;
        console.log(`Key transferred to Rex.`);
    }
}
export default Chip;
